import React, { Fragment } from "react";
import Project from "../../api/casestudies";
import { useParams } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import CtaSection from "../../components/CtaSection/CtaSection";
import icon from "../../images/icons/icon_check_3.svg";

const PortfolioSinglePage = () => {
  const { slug } = useParams();
  const PortfolioDetails = Project.find((item) => item.slug === slug);

  return (
    <Fragment>
      <main className="page_content about-page">
        <PageTitle pageTitle={PortfolioDetails.title} pageTop={"Case Study"} />
        <section className="portfolio_details_section section_space bg-light">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-12 d-flex justify-content-center align-items-center">
                <div>
                  <h2 className="details_item_title">
                    {PortfolioDetails.shorttitle}
                  </h2>
                  <p>{PortfolioDetails.singlepagedescription}</p>
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <div className="details_item_image">
                  <img src={PortfolioDetails.pImg} alt="Portfolio Item" />
                </div>
              </div>
            </div>

            <hr />

            <h3 className="details_item_info_title pt-4">
              Project Requirement
            </h3>
            <p>
              {PortfolioDetails.reqdecs}
            </p>
            <div className="row mb-4">
              {PortfolioDetails.requirements.map((item, index) => (
                <div className="col-lg-5 p-1" key={index}>
                  <ul className="icon_list unordered_list_block">
                    <li key={index}>
                      <span className="icon_list_icon">
                        <img src={icon} alt="Check SVG Icon" />
                      </span>
                      <span className="icon_list_text">{item}</span>
                    </li>
                  </ul>
                </div>
              ))}
            </div>

            <h3 className="details_item_info_title pt-4">Solution & Result</h3>

            <p>{PortfolioDetails.conclusion}</p>
          </div>
        </section>
        <CtaSection />
      </main>

      <Scrollbar />
    </Fragment>
  );
};
export default PortfolioSinglePage;
